import { combineReducers } from 'core/redux'

import instantReplyRequest from './instantReplyRequest'
import composerRequest from './composerRequest'

export default combineReducers({
  instantReplyRequest,
  composerRequest,
})
